module.exports = __webpack_public_path__ + "static/img/celoscope-28.099e722.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-28.jpg
// module id = Lh63
// module chunks = 52